import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Chargers" description="Manage charging equipment and status" />
      <TableSkeleton columns={7} />
    </>
  );
}
